// tempexp_18907-full-file
import { IS_AUTO_TEST_HIDE, IS_BIZ_USER, IS_CORP_USER, IS_SOCIAL_USER } from 'reactApp/appHelpers/configHelpers';
import { isSaveDiscountInOutlowEnabled } from 'reactApp/appHelpers/featuresHelpers/features/discountInOutflow';
import { loadBillingDataIfNotLoaded } from 'reactApp/modules/billingData/billingData.provider';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { BillingDataSubscriptionInfoStatus } from 'reactApp/modules/billingData/billingData.types';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { type RootState, store as reduxStore } from 'reactApp/store';
import {
    DISCOUNT_IN_OUTFLOW,
    DISCOUNT_IN_OUTFLOW_LAST_DAY_PROMO,
    discountInOutflowLogger,
    getDiscountRemainingDays,
} from 'reactApp/ui/DiscountInOutflow/DiscountInOutflow.const';
import { DiscountInOutflowSaveModalType } from 'reactApp/ui/DiscountInOutflow/DiscountInOutflowSaveModal/DiscountInOutflowSaveModal';
import { renderDiscountInOutflowSaveModal } from 'reactApp/ui/DiscountInOutflow/DiscountInOutflowSaveModal/DiscountInOutflowSaveModal.helpers';
import { getTimeToDate } from 'reactApp/utils/timeHelpers';
import { call, put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

export function* initDiscountInOutflowLastDayPromo() {
    const storage = yield* select(getCurrentStorage);
    const { isHome } = getStorage(storage);
    const discountFlagValue = storeHelper.getValue(DISCOUNT_IN_OUTFLOW);
    const expirationDate = new Date(discountFlagValue?.expirationDate);
    const isEnded = getTimeToDate(expirationDate) < 0;
    const subId = discountFlagValue?.subId;
    const alreadyShown = storeHelper.getValue(DISCOUNT_IN_OUTFLOW_LAST_DAY_PROMO);
    const remainingDays = getDiscountRemainingDays();
    const isLastDay = remainingDays === 0;

    const conditions = {
        alreadyShown,
        isNotLastDay: !isLastDay,
        isNotHome: !isHome,
        isFeatureFlagDisabled: !isSaveDiscountInOutlowEnabled,
        IS_CORP_USER,
        IS_BIZ_USER,
        IS_SOCIAL_USER,
        IS_AUTO_TEST_HIDE,
        hasNotLsFlag: !discountFlagValue,
        isEnded,
    };

    if (Object.values(conditions).includes(true)) {
        discountInOutflowLogger.error('init promo failure', conditions);
        return;
    }

    discountInOutflowLogger.ok('init promo success', conditions);

    yield put(
        addPromoToShowQueue({
            type: EPromoType.discountInOutflowLastDayPromo,
            promoId: DISCOUNT_IN_OUTFLOW_LAST_DAY_PROMO,
            onShow: () => {
                storeHelper.markAsShown(DISCOUNT_IN_OUTFLOW_LAST_DAY_PROMO);
                reduxStore.dispatch(promoShown(EPromoType.discountInOutflowLastDayPromo));
            },
            onClose: () => {
                reduxStore.dispatch(removePromo(EPromoType.discountInOutflowLastDayPromo));
            },
            subId,
        })
    );
}

export function* showDiscountInOutflowLastDayPromo() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.discountInOutflowLastDayPromo));

    if (!promo) {
        return;
    }

    const success = yield loadBillingDataIfNotLoaded();

    if (!success) {
        return;
    }

    const { onShow, onClose, subId } = promo;
    const subscription = yield* select((state: RootState) => BillingDataSelectors.getSubscriptionsById(state, subId));
    const isAlreadyActive = subscription?.status === BillingDataSubscriptionInfoStatus.ACTIVE;

    if (isAlreadyActive) {
        discountInOutflowLogger.error('show promo failure: sub already active');
        return;
    }

    yield call(renderDiscountInOutflowSaveModal, {
        analyticType: DiscountInOutflowSaveModalType.last,
        onShow,
        onClose,
        subscription,
        availabilityPeriod: 0,
    });
}
